import { render, staticRenderFns } from "./MoveTeamPresentations.vue?vue&type=template&id=975e32c2&scoped=true&"
import script from "./MoveTeamPresentations.vue?vue&type=script&lang=js&"
export * from "./MoveTeamPresentations.vue?vue&type=script&lang=js&"
import style0 from "./MoveTeamPresentations.vue?vue&type=style&index=0&id=975e32c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975e32c2",
  null
  
)

export default component.exports